import styled from 'styled-components';
import StyledSelect from 'components/ui/StyledSelect';

export const StyledDropdown = styled(StyledSelect)`
  display: block;
  height: 32px;
  margin-top: 0px;
  margin-bottom: 20px;
`;
